import React from 'react';
import { createPortal } from 'react-dom';
import { RiAlertLine } from 'react-icons/ri';

/* ══════════════════════════════════════════════════════════════
   QUIT CONFIRMATION

   Every exercise used to close the instant the ✕ was pressed, so a
   mis-aimed click threw away a session with no way back. This is the
   one dialog they all share.

   Portalled to <body> because the exercises it guards are themselves
   full-screen overlays at z-index 1200 — rendering inside them would
   put the dialog underneath the thing it is asking about.
══════════════════════════════════════════════════════════════ */

export default function QuitConfirm({
  open,
  title = 'Leave this exercise?',
  message = 'Your progress in this session will be lost.',
  confirmLabel = 'Leave',
  cancelLabel = 'Keep going',
  onConfirm,
  onCancel,
}) {
  if (!open) return null;

  return createPortal(
    <div className="quit-overlay" role="dialog" aria-modal="true" aria-label={title} onClick={onCancel}>
      <div className="quit-box anim-pop" onClick={e => e.stopPropagation()}>
        <div className="quit-icon"><RiAlertLine size={22} /></div>
        <h3>{title}</h3>
        <p>{message}</p>
        <div className="quit-actions">
          {/* Staying is the safe outcome, so it gets the default focus. */}
          <button type="button" className="btn-primary" onClick={onCancel} autoFocus>
            {cancelLabel}
          </button>
          <button type="button" className="btn-ghost quit-leave" onClick={onConfirm}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>,
    document.body,
  );
}
